module.exports = __webpack_public_path__ + "static/media/EMERALD.56904df7.png";